import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { AllValues } from '@/utils/types/types.util';
import { loadCorePermissionsFromStorage } from './permissions.storage';
import { type CorePermissions } from './permissions';

type CorePermissionValue = AllValues<typeof CorePermissions>;
type CorePermissionsStore = {
  corePermissions: CorePermissionValue[];
  setCorePermissions: (permissions: CorePermissionValue[]) => void;
};
const useCorePermissionsStore = create(
  devtools<CorePermissionsStore>((set) => ({
    corePermissions: loadCorePermissionsFromStorage(),
    setCorePermissions: (corePermissions) => {
      set({ corePermissions });
    },
  })),
);

export { useCorePermissionsStore };
